import React from "react";
import { useField } from "formik";

const SelectInput = ({ label, shouldShowError, options, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <div className="form-group col">
            <label className={"capitalize text-sm"} htmlFor={props.id || props.name}>{label}</label>
            <select className="custom-select" {...field} {...props}>
                <option value="">Select</option>
                {options && options.map((option, index)=>{
                    return <option
                        key={index}
                        value={option.value || option}
                    >
                        {option.name || option}
                    </option>
                })}
            </select>
            {shouldShowError || (meta.touched && meta.error) ? (
                <div className="text-danger">{meta.error}</div>
            ) : null}
        </div>
    );
};

export default SelectInput;